
function JuweloCatalogFilter(dom, attributes) {

    this.dom = dom;
    this.attributes = attributes;
    this.links = this.dom.find('li a');
    this.filtersLeft = jQuery(window).width() > 1024;
}

JuweloCatalogFilter.prototype.setForceFilterTop = function() {
    this.filtersLeft = false;
    this.onResize = function() {};
    this.dom.find('.filter-attribute-title,.filter-attribute-values').addClass('layered-collapsed');
    jQuery('body').removeClass('ab-test-filter-left');
    jQuery("#RangeSliderprice").trigger('resize');
};

JuweloCatalogFilter.prototype.onResize = function() {
    var filtersLeft = jQuery(window).width() > 1024;

    if(filtersLeft && !this.filtersLeft) {
        this.dom.find('.filter-option.active,.filter-option-default-expanded').find('.filter-attribute-title,.filter-attribute-values').removeClass('layered-collapsed');
    }
    if(!filtersLeft && this.filtersLeft) {
        this.dom.find('.filter-attribute-title,.filter-attribute-values').addClass('layered-collapsed');
    }

    this.filtersLeft = filtersLeft;
};

JuweloCatalogFilter.prototype.init = function() {
    var self = this;
    var uiOpenClose = this.dom.find('.filter-attribute-title,.filter-attribute-values');

    // recognize when filters are left or not
    this.onResize();
    jQuery(window).resize(function() {
        self.onResize();
    });

    if(!this.filtersLeft) {
        uiOpenClose.addClass('layered-collapsed');
    }

    for(var attributeId in this.attributes) {
        var attribute = this.attributes[attributeId];

        (function(attribute, filter) {

            // toggle attribute
            var dt = filter.dom.find('.filter-attribute-title.catalog-filter-attribute-'+attribute.code);
            var dd = filter.dom.find('.filter-attribute-values.catalog-filter-attribute-'+attribute.code);

            dt.click(function(e) {
                e.stopPropagation();
                if(dt.hasClass('layered-collapsed')) {
                    dt.removeClass('layered-collapsed');
                    dd.removeClass('layered-collapsed');
                } else {
                    if(jQuery(window).width() > 640 ){
                        dt.addClass('layered-collapsed');
                        dd.addClass('layered-collapsed');
                    } else {
                        if(jQuery(e.target).hasClass('back') || jQuery(e.target).hasClass('back-icon')){
                            dt.addClass('layered-collapsed');
                            dd.addClass('layered-collapsed');
                        }
                    }
                }
                // close all others on mobile
                if(!self.filtersLeft) {
                    uiOpenClose.not('.catalog-filter-attribute-'+attribute.code).addClass('layered-collapsed');
                }
            });
            var close = filter.dom.find('.filter-option-close .btn');
            close.click(function(){
                dt.addClass('layered-collapsed');
                dd.addClass('layered-collapsed');
            });

            // toggle show more
            var showall = dd.find('.layered-toggle-show-more');
            if(showall.length > 0) {
                showall.click(function() {
                    if(dd.hasClass('layered-show-all')) {
                        dd.removeClass('layered-show-all');
                    } else {
                        dd.addClass('layered-show-all');
                    }
                });
            }

        })(attribute, this);
    }

    // overlay on filter click
    var overlay = jQuery('.cart-progress');
    this.links.each(function(i, e) {
        var a = jQuery(e);
        a.click(function() {
            overlay.show();
            var li = a.parents('li:eq(0)');
            if(li.hasClass('layered-selected')) {
                li.removeClass('layered-selected');
            } else {
                li.addClass('layered-selected');
            }
            return true;
        });
    });
};

// inlines

jQuery(function() {
    
    // switch sort
    
    (function() {
        jQuery('select.category-list-sort-by').change(function() {
            window.location = jQuery(this).val();
        });
    })();
    
    // price filter
    
    (function() {
        var form = jQuery('.catalog-filter-attribute-price-form');
        if(form.length === 0) {
            return;
        }
        var defaultMax = parseInt(form.attr('data-maxPrice'));
        var baseUrl = form.attr('data-baseUrl');

        jQuery('#apply-price-filter').click(function() {

            var from = document.getElementById('price-from').value;
            var to = document.getElementById('price-to').value;

            var url = baseUrl;
            if(from === '' && to === '' && from === to) {
                url = baseUrl;
            } else {
                if(baseUrl.match(/\?/)) {
                    url += '&price=';
                    //price='+from+'-'+to;
                } else {
                    url += '?price='; //
                    // price='+from+'-'+to;
                }
                if(from === '') {
                    url += '0';
                } else {
                    url += from;
                }
                url += '-';
                if(to === '') {
                    url += defaultMax;
                } else {
                    url += to;
                }
            }

            document.location = url;
        });

        jQuery('#price-from,#price-to').on('keyup', function (e) {
            if(e.keyCode === 13) {
                jQuery('#apply-price-filter').trigger('click');
            }
        });
    })();
    
    // filter ui
    
    (function(){
        var element = jQuery('.category-filter');
        if(element.length === 0) {
            return;
        }
        var filter = new JuweloCatalogFilter(
            element,
            JSON.parse(element.attr('data-config'))
        );
        filter.init();

        jQuery('.filter-title').click(function(){
            if(!jQuery(this).hasClass('open')){
                jQuery(this).addClass('open');
                jQuery('.category-filter').addClass('open');
                if(jQuery(window).width() <= 640 ){
                    jQuery('html,body').animate({scrollTop: 0}, 10, 'swing');
                }
                jQuery('html').addClass('category-filter-open');
            } else {
                jQuery(this).removeClass('open');
                jQuery('.category-filter').removeClass('open');
                jQuery('html').removeClass('category-filter-open');
            }
        });

        jQuery('.filter-close').click(function(){
            jQuery('.filter-title').removeClass('open');
            jQuery('.category-filter').removeClass('open');
            jQuery('html').removeClass('category-filter-open');
        });

        // dropdown close all on outside click on mobile

        jQuery('body').click(function(e) {
            if(filter.filtersLeft) {
                return;
            }
            var clicked = jQuery(e.target);
            var option = clicked.parents('.filter-attribute:eq(0)');
            if(option.length === 0) {
                filter.dom.find('.filter-attribute-title,.filter-attribute-values').addClass('layered-collapsed');
            }
        });
    })();
    
});